import React from "react";
import ReactJson from "react-json-view";
import './json-content.scss';

interface Props {
  pageInfo: any;
}

const jsonMessageTheme = {
  scheme: "anywhere-json-message",
  author: "anywhere",
  base00: "rgba(0, 0, 0, 0)",
  base01: "#f5f5f5",
  base02: "#ffe7e9",
  base03: "#9ca3af",
  base04: "#6b7280",
  base05: "#4b5563",
  base06: "#374151",
  base07: "#4b5563",
  base08: "#d33682",
  base09: "#059669",
  base0A: "#ef4444",
  base0B: "#2563eb",
  base0C: "#6c71c4",
  base0D: "#4b5563",
  base0E: "#9333ea",
  base0F: "#2563eb",
};

export const EvidenceContentJSON = ({ pageInfo }: Props) => {
  const getData = () => {
    try {
      const data = pageInfo?.placeholderMapping ?? pageInfo;
      if (!data || typeof data !== 'object') return {};
      return JSON.parse(JSON.stringify(data));
    } catch {
      return {};
    }
  };

  return (
    <div className="e-text json-container">
      {/* <h2>{pageInfo.heading}</h2> */}
      <div className="e-paragraph">
        <ReactJson
          src={getData()}
          enableClipboard
          theme={jsonMessageTheme}
          displayDataTypes={false}
        />
      </div>
    </div>
  );
};


export const IncomingContentJSON = ({ pageInfo }: Props) => {
  const parseIncomingMessage = () => {
    try {
      const message = pageInfo?.incomingMessage;

      if (!message || message === 'undefined' || message === 'null') {
        return {};
      }

      if (typeof message === 'object') {
        return message;
      }

      return JSON.parse(message);
    } catch (error) {
      console.error('Failed to parse incoming message:', error);
      return {};
    }
  };

  return (
    <div className="e-text json-container">
      <div className="e-paragraph">
        <ReactJson
          src={parseIncomingMessage()}
          enableClipboard
          theme={jsonMessageTheme}
          displayDataTypes={false}
        />
      </div>
    </div>
  );
};